const AUTO_ARC_RATIO = 0.18;
const PLACED_EPSILON = 1;
/**
 * Unterscheidet geworfene Utility von platzierten Objekten. C4 wird nicht
 * geworfen, sondern gesetzt (Start === Ziel) und darf deshalb weder einen
 * Wurfbogen noch einen Effektradius bekommen. Editor und Quickview müssen
 * dieselbe Antwort bekommen — deshalb liegt die Regel hier und nicht in einem
 * der beiden Renderer.
 */
export function isPlacedUtility(utility) {
    if (utility.type === "C4")
        return true;
    return (Math.hypot(utility.target.x - utility.start.x, utility.target.y - utility.start.y) < PLACED_EPSILON);
}
export function throwApex(start, target, arcHeight) {
    const dx = target.x - start.x;
    const dy = target.y - start.y;
    const distance = Math.hypot(dx, dy) || 1;
    const height = arcHeight ?? distance * AUTO_ARC_RATIO;
    const nx = -dy / distance;
    const ny = dx / distance;
    return {
        x: (start.x + target.x) / 2 + nx * height,
        y: (start.y + target.y) / 2 + ny * height,
    };
}
